import { CheckCircle, XCircle, Bell, ChatCircleDots, UserSwitch, Megaphone, Scales } from "@phosphor-icons/react";

// Notification Center V2 — event_type -> presentation metadata. Add a new future event type
// here (e.g. work_order_updated) without touching the Notification Center's rendering logic —
// anything not listed falls back to a generic Bell icon.
export const EVENT_ICON = {
    VEHICLE_APPROVED: CheckCircle, VEHICLE_REJECTED: XCircle,
    COMPLAINT_CREATED: ChatCircleDots, COMPLAINT_STATUS_CHANGED: ChatCircleDots, COMPLAINT_ASSIGNED: UserSwitch,
    NOTICE_PUBLISHED: Megaphone,
    VOTE_PUBLISHED: Scales, VOTE_STARTED: Scales, VOTE_CLOSED: Scales, VOTE_RESULTS_AVAILABLE: Scales,
};
export const EVENT_ICON_COLOR = {
    VEHICLE_APPROVED: "text-green-600", VEHICLE_REJECTED: "text-brand-action",
    COMPLAINT_CREATED: "text-brand-ink", COMPLAINT_STATUS_CHANGED: "text-brand-ink", COMPLAINT_ASSIGNED: "text-brand-ink",
    NOTICE_PUBLISHED: "text-amber-600",
    VOTE_PUBLISHED: "text-indigo-600", VOTE_STARTED: "text-indigo-600", VOTE_CLOSED: "text-brand-inkSoft", VOTE_RESULTS_AVAILABLE: "text-indigo-600",
};
export const EVENT_LABEL = {
    VEHICLE_APPROVED: "Vehicle Approval", VEHICLE_REJECTED: "Vehicle Approval",
    COMPLAINT_CREATED: "Complaint", COMPLAINT_STATUS_CHANGED: "Complaint", COMPLAINT_ASSIGNED: "Complaint",
    NOTICE_PUBLISHED: "Notice",
    VOTE_PUBLISHED: "Voting", VOTE_STARTED: "Voting", VOTE_CLOSED: "Voting", VOTE_RESULTS_AVAILABLE: "Voting",
};

export function eventIcon(eventType) {
    return EVENT_ICON[eventType] || Bell;
}
export function eventIconColor(eventType) {
    return EVENT_ICON_COLOR[eventType] || "text-brand-inkSoft";
}
export function eventLabel(eventType) {
    return EVENT_LABEL[eventType] || "Update";
}
